"use client";
import React, { useState } from "react";
import {
    usePhoneCaptureTrigger
} from "@/src/components/Modals/components/PhoneCaptureModal/hooks/usePhoneCaptureTrigger";
import { PhoneCaptureModal } from "@/src/components/Modals/components/PhoneCaptureModal/modals/PhoneCaptureModal";
import { useFormContext } from "react-hook-form";
import { isWorkingTimeNow } from "@/src/shared/utils/isWorkingTime";
import {Modal, useMediaQuery} from "@mui/material";
import { ThankYouStage } from "@/src/components/Modals/components/TextUsModal/ThankYouStage";
import { BreakPointsPx, TextUsStages } from "@/src/shared/const";
import { useTextUsModalStore } from "@/src/stores/useTextUsModalStore";
import { useUpdateField } from "@/src/hooks/useFieldDebouncedCallback";

interface PhoneCaptureProps {
    activePage: string;
}

export const PhoneCapture: React.FC<PhoneCaptureProps> = ({activePage}) => {
    const FIVE_MIN_IN_SECONDS = 5 * 60 * 1000;

    const [showThankYou, setShowThankYou] = useState(false);

    const updateField = useUpdateField();
    const { reset: resetTextUs } = useTextUsModalStore();
    const { trigger, reset } = usePhoneCaptureTrigger(FIVE_MIN_IN_SECONDS, activePage);
    const { getValues, setValue } = useFormContext();
    const phoneModalShouldBeOpened = getValues('phoneModalShouldBeOpened');
    const isMobile = useMediaQuery(`(max-width:${BreakPointsPx.md})`);

    if((!phoneModalShouldBeOpened && !showThankYou) || isMobile) return;

    const descriptionText = `Залиште телефон – проконсультуємо без зобов’язань`;
    const submitButtonText = "Замовити консультацію";
    const exitTitle = 'Шановний Клієнте, маєте сумніви?';
    const timeoutTitle = 'Шановний Клієнте, є питання щодо оформлення?';

    const onClose = async ()=>{
        setValue('phoneModalShouldBeOpened', false);
        await updateField('phoneModalShouldBeOpened', false);
        resetTextUs();
    }

    const onSubmit = ()=>{
        setShowThankYou(!isWorkingTimeNow());
        resetTextUs();
    }

    const onCloseThankYouModal = () => {
        setShowThankYou(false);
        onClose();
    }

    return (
        <>
            {(trigger === 'exit' && !showThankYou) && <PhoneCaptureModal submitButtonText={submitButtonText} onClose={onClose} onSubmit={onSubmit} isOpen={true} title={exitTitle} description={descriptionText}/>}
            {(trigger === 'time' && !showThankYou) && <PhoneCaptureModal submitButtonText={submitButtonText} onClose={onClose} onSubmit={onSubmit} isOpen={true} title={timeoutTitle} description={descriptionText}/>}
            {(trigger && showThankYou) &&
                <Modal open={true} onClose={onCloseThankYouModal}>
                    <ThankYouStage
                        type={TextUsStages.ThankYouWeekend}
                        onAccept={() => {
                            console.log({trigger})
                            resetTextUs();
                            reset();
                            setShowThankYou(false);
                            onClose();
                        }}
                    />
                </Modal>
            }
        </>
    );
};
